module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-safari-permission-2a-4835b92cfba6fbf92fdbe24460fb1a88.png";